export const LEADERBOARD_ITEMS_PER_PAGE = 13;
